"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var tools_1 = require("../utils/tools");
var STRIKE_PATTERN = /line-through/i;
var NAME = 'strike';
var Strike = /** @class */ (function (_super) {
    __extends(Strike, _super);
    function Strike() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 's'; };
        _this.textMatcher = [
            {
                matcher: /\~\~([^~]+)\~\~\s$/
            }
        ];
        _this.parseDOM = [
            { tag: 's', priority: 25 },
            { tag: 'strike', priority: 25 },
            { tag: 'del', priority: 25 },
            {
                style: 'text-decoration-line',
                getAttrs: getAttrs
            }
        ];
        return _this;
    }
    return Strike;
}(core_utilities_1.Inline));
exports.Strike = Strike;
function getAttrs(value) {
    if (STRIKE_PATTERN.test(value)) {
        return true;
    }
    return false;
}
var StrikeController = /** @class */ (function (_super) {
    __extends(StrikeController, _super);
    function StrikeController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'strike',
            tooltip: 'strike'
        };
        _this.disable = function (editor) {
            return tools_1.checkMarkDisable(editor.view, NAME);
        };
        return _this;
    }
    return StrikeController;
}(core_utilities_1.SylController));
exports.StrikeController = StrikeController;
var StrikePlugin = /** @class */ (function (_super) {
    __extends(StrikePlugin, _super);
    function StrikePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = StrikeController;
        _this.Schema = Strike;
        return _this;
    }
    return StrikePlugin;
}(core_utilities_1.SylPlugin));
exports.StrikePlugin = StrikePlugin;
//# sourceMappingURL=strike.js.map